// extracted by mini-css-extract-plugin
module.exports = {"error":"_6c968c3e","private":"_cb5bd0ab","access":"_a59858c2"};